<template>
    <td-dialog
        :title="$t(title)"
        :before-close="dialogLeaveBillPicClose"
        :visible.sync="dialogLeaveBillPicVisible"
        width="1400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container style="height:550px">
            <el-main>
                <img :src="'data:image/jpg;base64,' + item" />
            </el-main>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button @click="btnCancel">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['title', 'dialogLeaveBillPicVisible', 'param', 'editItem'],
    // 定义变量
    data() {
        return {
            item: ''
        };
    },
    mounted() {
        this.btnQuery();
    },
    // 定义并实现方法体
    methods: {
        // 查询流程号对应流程信息
        btnQuery() {
            let param = {
                workFlowCode: this.param.processInstanceId
            };
            Api.queryLeaveBillPicByCode(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/queryLeaveBillByCode/queryLeaveBillByCode', response.data.statusMessage);
                    return;
                }
                this.item = response.data.content;
            });
        },
        btnCancel() {
            this.$emit('dialogLeaveBillPicClose');
        },
        // 关闭窗口之前需要调用的方法
        dialogLeaveBillPicClose() {
            this.$emit('dialogLeaveBillPicClose');
            this.dialogLeaveBillPicVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
